import SeoReportsComponent from './SeoReports.component';

const SeoReportsPage = function (): JSX.Element {
  // TODO: fetch aggregated report data from audits + keywords
  const summary = {
    totalIssues: 0,
    issuesFixedThisMonth: 0,
    avgPositionChange: 0,
    pagesAnalyzed: 0,
  };

  return <SeoReportsComponent summary={summary} isLoading={false} />;
};

export default SeoReportsPage;
